import { render, staticRenderFns } from "./dialog-save-tenant.vue?vue&type=template&id=4844ade2&scoped=true&"
import script from "./dialog-save-tenant.vue?vue&type=script&lang=js&"
export * from "./dialog-save-tenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4844ade2",
  null
  
)

export default component.exports